module.exports = __webpack_public_path__ + "static/cachacaGestor-50b0b9a59615a476f40fdbdc589f8559.png";